<template><div><h1 id="verdankungen-anlassspende" tabindex="-1"><a class="header-anchor" href="#verdankungen-anlassspende"><span>Verdankungen (Anlassspende)</span></a></h1>
<p>Verdankungen — Parameter und Protokolle eines Verdankungsjobs für Anlassspenden</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Parameter, das Protokoll und die Funktionen des Jobs <RouteLink to="/referenz/refs/ft.refproc.anlspeverdank.html" title="Verdankungen aufbereiten (Anlassspenden)">Verdankungslauf erfassen (Anlassspende)</RouteLink> werden hier zur Verfügung gestellt.</p>
<p>Pfad: <code v-pre>Personen → Anlassspenden → Verdankungen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Job-Datum + Lauf-Nr. (Job-Id)</dt>
<dd>Datum und Laufnummer (fortlaufend nummeriert, wenn mehrere Läufe pro Tag durchgeführt werden) zur Identifikation des Laufes</dd>
<dt>Status</dt>
<dd>Status des angezeigten Laufes. Folgende Stati sind möglich:
<table>
<thead>
<tr>
<th>Status</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>1</td>
<td>erfasst, noch nicht aufbereitet</td>
</tr>
<tr>
<td>2</td>
<td>in Bearbeitung</td>
</tr>
<tr>
<td>3</td>
<td>aufbereitet, beendet</td>
</tr>
</tbody>
</table>
</dd>
<dt>Anlassereignis/-Position</dt>
<dd>Zu verdankendes <a class="link" href="ft.refdata.ereigkopf.html" title="Ereignisse">Ereignis</a> mit <a class="link" href="ft.refdata.ereigpos.html" title="Ereignispositionen">Ereignisposition</a></dd>
<dt>verdanken ab Betrag</dt>
<dd>Nur Spenden ab eingegebenem Betrag verdanken</dd>
<dt>Anzahl</dt>
<dd>Anzahl Verdankungen, die in der angegebenen Druckdatei gespeichert wurden</dd>
<dt>Druckdatei</dt>
<dd>Pfad und Dateinamen des Exportfiles</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="verdankungslauf-erfassen" tabindex="-1"><a class="header-anchor" href="#verdankungslauf-erfassen"><span>Verdankungslauf erfassen</span></a></h3>
<p>Erfassen und parametrisieren des Verdankungsjobs, siehe <RouteLink to="/referenz/refs/ft.refproc.anlspeverdank.html" title="Verdankungen aufbereiten (Anlassspenden)">Averdankungslauf erfassen (Anlassspende).</RouteLink></p>
<h3 id="verdankungslauf-erneut-starten" tabindex="-1"><a class="header-anchor" href="#verdankungslauf-erneut-starten"><span>Verdankungslauf erneut starten</span></a></h3>
<p>Startet nochmals den Aufbereitungsjob. Dies ist nur dann notwendig, wenn ein Job zurückgesetzt worden ist.</p>
<h3 id="verdankungslauf-zurucksetzen" tabindex="-1"><a class="header-anchor" href="#verdankungslauf-zurucksetzen"><span>Verdankungslauf zurücksetzen</span></a></h3>
<p>Setzt einen Verdankungsjob zurück, sodass er noch ein wiederholt gestartet werden kann, beispielsweise nach einer Änderung der Steuertabelle.</p>
<h3 id="word-steuerdatei-erneut-erstellen" tabindex="-1"><a class="header-anchor" href="#word-steuerdatei-erneut-erstellen"><span>Word-Steuerdatei erneut erstellen</span></a></h3>
<p>Erstellt nochmals die Word-Steuerdatei.</p>
<h3 id="adressetiketten-erneut-erstellen" tabindex="-1"><a class="header-anchor" href="#adressetiketten-erneut-erstellen"><span>Adressetiketten erneut erstellen</span></a></h3>
<p>Generiert erneut die Etiketten für diesen Job.</p>
<h3 id="verdankungsbriefe-drucken" tabindex="-1"><a class="header-anchor" href="#verdankungsbriefe-drucken"><span>Verdankungsbriefe drucken</span></a></h3>
<p>Druckt die Verdankungsbriefe, resp. erzeugt einen Output mit Verdanksbriefen.</p>
<h3 id="protokoll-drucken" tabindex="-1"><a class="header-anchor" href="#protokoll-drucken"><span>Protokoll drucken</span></a></h3>
<p>Erzeugt erneut das Protokoll für diesen Job.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refproc.anlspeverdank.html" title="Verdankungen aufbereiten (Anlassspenden)">Verdankungslauf erfassen (Anlassspende)</RouteLink></p>
</div></template>


